<template>
  <Component :is="component" :size="normalizedSize" :color="normalizedColor" />
</template>

<script>
import _ from 'lodash';
import VueTypes from 'vue-types';

import { lsColors } from '@/constants';
import { LsIconTypes, LsIconSizes } from './LsIcon.constants';
import AddSVG from './components/AddSVG.vue';
import AscendingSVG from './components/AscendingSVG.vue';
import CalendarSVG from './components/CalendarSVG.vue';
import CancelSVG from './components/CancelSVG.vue';
import ChatSVG from './components/ChatSVG.vue';
import CheckfullSVG from './components/CheckfullSVG.vue';
import CheckmarkSVG from './components/CheckmarkSVG.vue';
import CheckSVG from './components/CheckSVG.vue';
import ChevronSVG from './components/ChevronSVG.vue';
import CirclepulseSVG from './components/CirclepulseSVG.vue';
import ClockfSVG from './components/ClockfSVG.vue';
import ClockSVG from './components/ClockSVG.vue';
import CloseSVG from './components/CloseSVG.vue';
import CopySVG from './components/CopySVG.vue';
import CreditcardSVG from './components/CreditcardSVG.vue';
import DashesSVG from './components/DashesSVG.vue';
import DeniedSVG from './components/DeniedSVG.vue';
import DescendingSVG from './components/DescendingSVG.vue';
import DragSVG from './components/DragSVG.vue';
import EditSVG from './components/EditSVG.vue';
import EmailSVG from './components/EmailSVG.vue';
import ExclamationSVG from './components/ExclamationSVG.vue';
import FacebookSVG from './components/FacebookSVG.vue';
import FertilizerSVG from './components/FertilizerSVG.vue';
import GiftSVG from './components/GiftSVG.vue';
import GoogleSVG from './components/GoogleSVG.vue';
import HamburgerSVG from './components/HamburgerSVG.vue';
import HourglassSVG from './components/HourglassSVG.vue';
import MobileSVG from './components/MobileSVG.vue';
import MoreSVG from './components/MoreSVG.vue';
import NextdoorSVG from './components/NextdoorSVG.vue';
import PhoneSVG from './components/PhoneSVG.vue';
import PhotoSVG from './components/PhotoSVG.vue';
import PinSVG from './components/PinSVG.vue';
import QuoteSVG from './components/QuoteSVG.vue';
import ResizeSVG from './components/ResizeSVG.vue';
import SkipSVG from './components/SkipSVG.vue';
import StaroutlineSVG from './components/StaroutlineSVG.vue';
import StarSVG from './components/StarSVG.vue';
import ThumbsupSVG from './components/ThumbsupSVG.vue';
import ThunderSVG from './components/ThunderSVG.vue';
import TwitterSVG from './components/TwitterSVG.vue';
import UserSVG from './components/UserSVG.vue';

export default {
  name: 'LsIcon',
  components: {
    AddSVG,
    AscendingSVG,
    CalendarSVG,
    CancelSVG,
    ChatSVG,
    CheckfullSVG,
    CheckmarkSVG,
    CheckSVG,
    ChevronSVG,
    CirclepulseSVG,
    ClockfSVG,
    ClockSVG,
    CloseSVG,
    CopySVG,
    CreditcardSVG,
    DashesSVG,
    DeniedSVG,
    DescendingSVG,
    DragSVG,
    EditSVG,
    EmailSVG,
    ExclamationSVG,
    FacebookSVG,
    FertilizerSVG,
    GiftSVG,
    GoogleSVG,
    HamburgerSVG,
    HourglassSVG,
    MobileSVG,
    MoreSVG,
    NextdoorSVG,
    PhoneSVG,
    PhotoSVG,
    PinSVG,
    QuoteSVG,
    ResizeSVG,
    SkipSVG,
    StaroutlineSVG,
    StarSVG,
    ThumbsupSVG,
    ThunderSVG,
    TwitterSVG,
    UserSVG,
  },
  props: {
    type: {
      type: String,
      required: true,
      validator(value) {
        return _.includes(LsIconTypes, value);
      },
    },
    color: {
      type: String,
      default: 'primary',
      validator(value) {
        return _.includes(_.keys(lsColors), value);
      },
    },
    size: {
      type: String,
      default: 'sm',
      validator(value) {
        return _.includes(_.keys(LsIconSizes), value);
      },
    },
    sizeOverride: VueTypes.integer,
  },
  computed: {
    normalizedSize() {
      return this.sizeOverride || LsIconSizes[this.size];
    },
    normalizedColor() {
      return lsColors[this.color];
    },
    component() {
      return _.get(this.$options.components, `${_.startCase(this.type)}SVG`);
    },
  },
};
</script>

<style></style>
